import { Controller } from '@hotwired/stimulus';
import { useModal } from '../js/stimulus_use/use-modal';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'message',
        'error',
        'emailCopy',
        'submitButton',
        'formView',
        'footer',
        'successView',
    ];

    static values = {
        minLength: Number,
        maxLength: Number,
        submitUrl: String,
        autoOpen: Boolean,
    };

    connect() {
        useModal(this);

        if (this.autoOpenValue) {
            this.open();
        }
    }

    onHide() {
        this.reset();
    }

    async submit() {
        const message = this.messageTarget.value.trim();

        // Mandatory field.
        if (message.length === 0) {
            this.showError('Ce champ est obligatoire.');

            return;
        }

        // Minimum length.
        if (message.length < this.minLengthValue) {
            const missing = this.minLengthValue - message.length;

            this.showError(
                `Votre réponse doit contenir au moins ${this.minLengthValue} caractères (il en manque ${missing}).`,
            );

            return;
        }

        if (message.length > this.maxLengthValue) {
            const excess = message.length - this.maxLengthValue;

            this.showError(
                `Votre réponse ne doit pas dépasser ${this.maxLengthValue} caractères (il y en a ${excess} de trop).`,
            );

            return;
        }

        this.clearError();
        this.setSubmitting(true);

        try {
            const body = new FormData();
            body.append('message', message);
            body.append('email_copy', this.emailCopyTarget.checked ? '1' : '0');

            const response = await fetch(this.submitUrlValue, {
                method: 'POST',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body,
            });

            const data = await response.json().catch(() => ({}));

            if (!response.ok || !data.status) {
                this.showError(data.message || "Une erreur est survenue, veuillez réessayer.");
                this.setSubmitting(false);

                return;
            }

            this.showSuccess();
        } catch (error) {
            this.showError("Une erreur est survenue, veuillez réessayer.");
            this.setSubmitting(false);
        }
    }

    setSubmitting(isSubmitting) {
        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = isSubmitting;
        }
    }

    showError(text) {
        this.errorTarget.textContent = text;
        this.errorTarget.classList.remove('d-none');
        this.messageTarget.classList.add('is-invalid');
    }

    clearError() {
        this.errorTarget.classList.add('d-none');
        this.messageTarget.classList.remove('is-invalid');
    }

    showSuccess() {
        this.formViewTarget.style.display = 'none';
        this.footerTarget.style.display = 'none';
        this.successViewTarget.style.display = 'block';
    }

    reset() {
        // Closed-ad view has no form targets — nothing to reset.
        if (!this.hasMessageTarget) {
            return;
        }

        this.messageTarget.value = '';
        this.emailCopyTarget.checked = true;
        this.clearError();
        this.setSubmitting(false);

        this.successViewTarget.style.display = 'none';
        this.formViewTarget.style.display = 'block';
        this.footerTarget.style.display = 'flex';
    }
}
